import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetVolumeInOptions } from 'constants/businessTool';

import { IVolumeSelectorProps } from './types';
import { BaseSelector } from '../../../../../../components/BaseSelector/BaseSelector';

export const VolumeSelector: FC<IVolumeSelectorProps> = ({ name, disabled }) => {
  const { t } = useTranslation();
  const VOLUME_IN_OPTIONS = useGetVolumeInOptions();
  return (
    <BaseSelector
      label={t('volumeIn')}
      name={name}
      disabled={disabled}
      options={VOLUME_IN_OPTIONS}
      defaultValue={VOLUME_IN_OPTIONS[0].value}
      renderValue={(value) => <>{value}</>}
    />
  );
};
